// nav bar hamburger
$(document).ready(function () {
  $(".hamburger button").click(function () {
    $(this).toggleClass("active");
    $(".navbar").toggleClass("active");
    $("body").toggleClass("dimmed", $(".navbar").hasClass("active"));

    if ($(this).hasClass("active")) {
      $("html").addClass("overflow");
    } else {
      $("html").removeClass("overflow");
    }
  });
});

// culture slider
$(document).ready(function () {
  var owl = $(".hero-slider");

  owl.owlCarousel({
    loop: true,
    autoplay: true,
    smartSpeed: 2000,
    margin: 10,
    nav: false,
    dots: true,
    responsive: {
      0: {
        items: 1,
      },
      600: {
        items: 1,
      },
      992: {
        items: 1,
      },
    },
  });

  $(".custom-prev").click(function () {
    owl.trigger("prev.owl.carousel");
  });

  $(".custom-next").click(function () {
    owl.trigger("next.owl.carousel");
  });
});

// category slider
$(document).ready(function () {
  var owl = $(".category-slider");

  owl.owlCarousel({
    loop: true,
    autoplay: true,
    // smartSpeed: 2000,
    margin: 24,
    nav: false,
    dots: false,
    responsive: {
      0: {
        items: 1,
      },
      768: {
        items: 2,
      },
      992: {
        items: 3,
      },
      1280: {
        items: 4,
      },
    },
  });

  $(".category-prev").click(function () {
    owl.trigger("prev.owl.carousel");
  });

  $(".category-next").click(function () {
    owl.trigger("next.owl.carousel");
  });
});

// premium details

$(".premium-detail").hide();

$(".bundel-top").click(function () {
  var $bundleInclude = $(this).closest(".premium-bundle-include");
  var $premiumDetail = $bundleInclude.find(".premium-detail");

  $premiumDetail.slideToggle("slow");

  $bundleInclude.toggleClass("pre-active");
});

// featured-slider-2
$(document).ready(function () {
  var owl = $(".featured-slider-2");

  owl.owlCarousel({
    rtl: true,
    loop: true,
    center: true,
    autoplay: false,
    autoplaySpeed: 2000,
    margin: 32,
    nav: false,
    dots: false,
    responsive: {
      0: {
        items: 1,
        center: false,
        stagePadding: 10,
        center: false,
      },
      768: {
        items: 1.5,
      },
      992: {
        items: 2.2,
      },
      1280: {
        items: 3.2,
      },
    },
  });
});

// featured-slider-1
$(document).ready(function () {
  var owl = $(".featured-slider-1");

  owl.owlCarousel({
    loop: true,
    autoplay: false,
    margin: 32,
    nav: false,
    dots: false,
    autoplaySpeed: 3000,
    stagePadding: 240,
    responsive: {
      0: {
        items: 1,
        stagePadding: 10,
      },
      768: {
        items: 1,
        stagePadding: 140,
      },
      992: {
        items: 1.2,
      },
      1280: {
        items: 2,
      },
    },
  });
});
//Home best-pro-slider
$(window).on('load', function () {
  var owl = $(".index-best-pro-slider");

  owl.owlCarousel({
    loop: true,
    autoplay: false,
    margin: 24,
    nav: false,
    dots: false,
    autoplaySpeed: 3000,
    responsive: {
      0: {
        items: 1,
      },
      768: {
        items: 2,
      },
      992: {
        items: 2.5,
      },
      1280: {
        items: 3.5,
      },
    },
    onInitialized: highlightFirstActiveItem,
    onTranslated: highlightFirstActiveItem,
  });

  function highlightFirstActiveItem(event) {
    var $items = $(".index-best-pro-slider .owl-item");
    $items.removeClass("first-active-item");
    $items.filter(".active").first().addClass("first-active-item");
  }

  $(".pro-prev").click(function () {
    owl.trigger("prev.owl.carousel");
  });

  $(".pro-next").click(function () {
    owl.trigger("next.owl.carousel");
  });
});

//Product Recomendation
$(window).on('load', function () {
  setTimeout(function() {
    var owl = $(".like-prod-slider");

    owl.owlCarousel({
      loop: false,
      autoplay: false,
      margin: 24,
      nav: false,
      dots: false,
      autoplaySpeed: 3000,
      responsive: {
        0: {
          items: 1,
        },
        768: {
          items: 2,
        },
        992: {
          items: 2.5,
        },
        1280: {
          items: 3.5,
        },
      },
      onInitialized: highlightFirstActiveItem,
      onTranslated: highlightFirstActiveItem,
    });

    function highlightFirstActiveItem(event) {
      var $items = $(".like-prod-slider .owl-item");
      $items.removeClass("first-active-item");
      $items.filter(".active").first().addClass("first-active-item");
    }

    $(".pro-prev").click(function () {
      owl.trigger("prev.owl.carousel");
    });

    $(".pro-next").click(function () {
      owl.trigger("next.owl.carousel");
    });
  }, 300); // You can adjust the delay as needed
});



// blog slider
$(document).ready(function () {
  var owl = $(".blog-slider");

  owl.owlCarousel({
    loop: true,
    autoplay: true,
    margin: 24,
    smartSpeed: 2000,
    nav: false,
    dots: false,
    center: true,
    responsive: {
      0: {
        items: 1.2,
      },
      992: {
        items: 2,
      },
      992: {
        items: 1.5,
      },
    },
  });

  $(".blog-prev").click(function () {
    owl.trigger("prev.owl.carousel");
  });

  $(".blog-next").click(function () {
    owl.trigger("next.owl.carousel");
  });
});

// footer dropdown
// $(document).ready(function () {
//   $(".foot-link h5").click(function () {
//     var $this = $(this);
//     var $ul = $this.next("ul");
//     var $arrow = $this.find("img");

//     $ul.slideToggle();

//     $arrow.toggleClass("rotated");

//     $(".foot-link ul").not($ul).slideUp();
//     $(".foot-link h5 img").not($arrow).removeClass("rotated");
//   });
// });

$(document).ready(function () {
  function toggleFooterLinks() {
    if ($(window).width() < 768) {
      $(".foot-link h5").off('click').on('click', function () {
        var $this = $(this);
        var $ul = $this.next("ul");
        var $arrow = $this.find("img");

        $ul.slideToggle();
        $arrow.toggleClass("rotated");

        $(".foot-link ul").not($ul).slideUp();
        $(".foot-link h5 img").not($arrow).removeClass("rotated");
      });
    } else {
      $(".foot-link ul").removeAttr("style");
      $(".foot-link h5 img").removeClass("rotated");
    }
  }

  toggleFooterLinks();

  $(window).resize(function () {
    toggleFooterLinks();
  });
});



// category product slider
$(document).ready(function () {
  var owl = $(".product-slider");

  owl.owlCarousel({
    loop: true,
    rtl: false,
    autoplay: true,
    // smartSpeed: 2000,
    margin: 24,
    nav: false,
    dots: false,
    responsive: {
      0: {
        items: 1,
      },
      768: {
        items: 1.2,
      },
      800: {
        items: 1.2,
      },
      1280: {
        items: 2.2,
      },
      1281: {
        items: 3.2,
      },
    },
  });

  $(".product-prev").click(function () {
    owl.trigger("prev.owl.carousel");
  });

  $(".product-next").click(function () {
    owl.trigger("next.owl.carousel");
  });
});
// category product slider 2
$(document).ready(function () {
  var owl = $(".product-slider-2");

  owl.owlCarousel({
    loop: true,
    rtl: true,
    autoplay: true,
    // smartSpeed: 2000,
    margin: 24,
    nav: false,
    dots: false,
    responsive: {
       0: {
        items: 1,
      },
      768: {
        items: 1.2,
      },
      800: {
        items: 1.2,
      },
      1280: {
        items: 2.2,
      },
      1281: {
        items: 3.2,
      },
    },
  });

  $(".product-prev").click(function () {
    owl.trigger("prev.owl.carousel");
  });

  $(".product-next").click(function () {
    owl.trigger("next.owl.carousel");
  });
});

// product detail tabbing

$(document).ready(function () {
  $(".single-tab").first().addClass("active-product-tab");

  $(".single-tab").on("click", function () {
    $(".single-tab").removeClass("active-product-tab");

    $(this).addClass("active-product-tab");
  });
});

$(document).ready(function () {
  $(".single-tab").click(function () {
    var tab_id = $(this).attr("data-tab");

    $(".single-tab").removeClass("current");
    $(".tab-content").removeClass("current");

    $(this).addClass("current");
    $("#" + tab_id).addClass("current");
  });
});

//faq

$(document).ready(function () {
  function activateFirstQuestion() {
    var $firstQAContentInTab = $(".tab-content.current .QA-content:first");
    var $firstQAContent = $firstQAContentInTab.length
      ? $firstQAContentInTab
      : $(".QA-content:first");

    if ($firstQAContent.length) {
      $firstQAContent.find(".answer").slideDown();
      $firstQAContent.addClass("answer-active");
      $firstQAContent.find(".Question").addClass("question-active");
      $firstQAContent.find(".Question img").attr("src", "https://cdn.shopify.com/s/files/1/0897/4047/6710/files/minus.svg?v=1725448646");
    }
  }

  activateFirstQuestion();

  $(".Question").click(function () {
    var $qaContent = $(this).closest(".QA-content");
    var $answer = $qaContent.find(".answer");
    var $img = $(this).find("img");

    $(".answer").not($answer).slideUp();
    $(".QA-content").not($qaContent).removeClass("answer-active");
    $(".QA-content .Question img").attr("src", "https://cdn.shopify.com/s/files/1/0897/4047/6710/files/plus.svg?v=1725448579");

    $answer.slideToggle();
    $qaContent.toggleClass("answer-active");

    if ($qaContent.hasClass("answer-active")) {
      $img.attr("src", "https://cdn.shopify.com/s/files/1/0897/4047/6710/files/minus.svg?v=1725448646");
    } else {
      $img.attr("src", "https://cdn.shopify.com/s/files/1/0897/4047/6710/files/plus.svg?v=1725448579");
    }

    $(this).toggleClass("question-active");
    $(".Question").not(this).removeClass("question-active");
  });

  $(".related-box ul li").click(function () {
    var tab_id = $(this).attr("data-tab");

    $(".QA-content").removeClass("answer-active");
    $(".Question").removeClass("question-active");
    $(".Question img").attr("src", "https://cdn.shopify.com/s/files/1/0897/4047/6710/files/plus.svg?v=1725448579");
    $(".answer").slideUp();

    $(".related-box ul li").removeClass("current");
    $(".tab-content").removeClass("current");

    $(this).addClass("current");
    $("#" + tab_id).addClass("current");

    activateFirstQuestion();
  });
});

//phone number
$("#phoneNumber").on("input", function () {
  var phoneNumber = $(this).val();

  phoneNumber = phoneNumber.replace(/\D/g, "");

  if (phoneNumber.length > 14) {
    phoneNumber = phoneNumber.substring(0, 14);
  }

  $(this).val(phoneNumber);
});

// faq type active

$(document).ready(function () {
  $(".related-box ul li:first").addClass("type-active");

  $(".related-box ul li").click(function () {
    $(".related-box ul li").removeClass("type-active");
    $(this).addClass("type-active");
  });
});

// faq tabbing

$(document).ready(function () {
  $(".related-box ul li").click(function () {
    var tab_id = $(this).attr("data-tab");

    $(".related-box ul li").removeClass("current");
    $(".tab-content").removeClass("current");

    $(this).addClass("current");
    $("#" + tab_id).addClass("current");
  });
});


$(document).ready(function() {
    // Get the current page URL and normalize it (remove trailing slash)
    var currentUrl = window.location.href.split('?')[0].replace(/\/$/, ''); 

    // Loop through each link in the ul and normalize the href (remove trailing slash)
    $('ul.header__linklist.list--unstyled.hidden-pocket.hidden-lap li a').each(function() {
        var linkUrl = $(this).attr('href').replace(/\/$/, ''); // Normalize link URL
       

        // Use `includes` to match parts of the URL, or `indexOf` if more specific
        if (currentUrl.includes(linkUrl)) {
            $(this).addClass('menu-btn-active');
        }
    });
});

$(document).ready(function() {
    // Get the current page URL and normalize it (remove trailing slash)
    var currentUrl = window.location.href.split('?')[0].replace(/\/$/, ''); 

    // Loop through each link in the ul and normalize the href (remove trailing slash)
    $('#footer ul li a').each(function() {
        var linkUrl = $(this).attr('href').replace(/\/$/, ''); // Normalize link URL

        // Use `includes` to match parts of the URL, or `indexOf` if more specific
        if (currentUrl.includes(linkUrl)) {
            $(this).addClass('menu-btn-active');
        }
    });
});

// position sticky
// $(document).ready(function () {
//   function adjustBodyOverflow() {
//     var $body = $('body');
//     var $faqTypesDiv = $('.faq-types');
//     if ($faqTypesDiv.length > 0) {
//       $body.css('overflow', 'unset');
//     } else {
//       $body.css('overflow', 'hidden');
//     }
//   }
//   adjustBodyOverflow();
// });




 $(document).ready(function(){
    $('.productSliderRow').slick({
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 1.09,  // Keeps the first slide slightly visible on the left
        adaptiveHeight: true,
        centerMode: true,    // Centering the active slide
        initialSlide: 1,     // Start from the second slide to shift it left initially
        nextArrow: `
            <button type="button" class="slick-next">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                    <path d="M5.50016 1.69271C5.50367 1.84126 5.5658 1.98239 5.67301 2.08529L12.5878 9.00008L5.67301 15.9149C5.61901 15.9673 5.57609 16.03 5.54678 16.0994C5.51746 16.1687 5.50236 16.2432 5.50235 16.3184C5.50238 16.4304 5.53581 16.5398 5.59835 16.6326C5.6609 16.7255 5.74973 16.7975 5.85346 16.8396C5.9572 16.8817 6.07113 16.8919 6.18068 16.8688C6.29023 16.8458 6.39042 16.7906 6.46842 16.7103L13.7809 9.39779C13.8864 9.29229 13.9456 9.14924 13.9456 9.00008C13.9456 8.85092 13.8864 8.70787 13.7809 8.60238L6.46842 1.28988C6.38991 1.20808 6.28852 1.15191 6.17753 1.12874C6.06655 1.10557 5.95115 1.11647 5.84647 1.16002C5.74179 1.20357 5.65271 1.27774 5.59091 1.37279C5.52911 1.46785 5.49748 1.57936 5.50016 1.69271Z" fill="white"/>
                </svg>
            </button>`,

      responsive: [
            {
                breakpoint: 1025, // At or below 1024px
                settings: {
                    slidesToShow: 2.2 ,// Display more slides below 1025p6
                   // centerMode: false,  
                }
            },
            {
                breakpoint: 769, // Further adjustments for smaller screens
                settings: {
                    slidesToShow: 1.7, // Show one slide on small screens
                    // centerMode: false
                }
            },

        {
                breakpoint: 768, // Further adjustments for smaller screens
                settings: {
                    slidesToShow: 1, // Show one slide on small screens
                    centerMode: false
                }
            }
        ]
       
      
    });

    
});
